// app/redux/sagas/formationsSaga.js
import { call, put } from "redux-saga/effects";
import Swal from "sweetalert2";
import {
    FETCH_FORMATIONS_SUCCESS,
    FETCH_FORMATIONS_FAIL,

    CREATE_FORMATION_SUCCESS,
    CREATE_FORMATION_FAIL,

    UPDATE_FORMATION_SUCCESS,
    UPDATE_FORMATION_FAIL,

    DELETE_FORMATION_SUCCESS,
    DELETE_FORMATION_FAIL,

    DOWNLOAD_FORMATIONS_TEMPLATE_SUCCESS,
    DOWNLOAD_FORMATIONS_TEMPLATE_FAIL,

    IMPORT_FORMATIONS_EXCEL_SUCCESS,
    IMPORT_FORMATIONS_EXCEL_FAIL,

    EXPORT_FORMATIONS_SUCCESS,
    EXPORT_FORMATIONS_FAIL,

    fetchFormationsRequest,
} from "../actions/formationsActions";

import { API_BASE_URL, getRequest, postRequest, putRequest, deleteRequest, getBlobRequest } from "../../../api";



import {
    FETCH_FORMATIONS_BY_CATALOGUE_SUCCESS,
    FETCH_FORMATIONS_BY_CATALOGUE_FAIL,
} from "../actions/formationsActions";



export function* fetchFormationsByCatalogueSaga(action) {
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid"); // si ton backend utilise header uid
    const catalogueId = action?.payload?.catalogueId;

    try {
        if (!catalogueId || String(catalogueId) === "all") {
            // soit afficher vide :
            yield put({ type: FETCH_FORMATIONS_BY_CATALOGUE_SUCCESS, payload: [] });

            // soit appeler getAll (si tu préfères) :
            // const res = yield call(getRequest, { url: `${API_BASE_URL}/api/formations`, token, headers:{uid} });
            // yield put({ type: FETCH_FORMATIONS_BY_CATALOGUE_SUCCESS, payload: res.data });

            return;
        }

        const res = yield call(getRequest, {
            url: `${API_BASE_URL}/api/formations/catalogues/${catalogueId}/formations`,
            token,
            headers: { uid }, // ✅ important si ton backend lit uid en header
        });

        yield put({ type: FETCH_FORMATIONS_BY_CATALOGUE_SUCCESS, payload: res.data });
    } catch (e) {
        const msg = e.response?.data?.message || e.message;
        yield put({ type: FETCH_FORMATIONS_BY_CATALOGUE_FAIL, payload: msg });
    }
}

export function downloadBlob(blob, filename) {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
}

/* ======================
   FETCH LIST
====================== */
export function* fetchFormationsSaga() {
    const token = sessionStorage.getItem("token");
    try {
        const res = yield call(getRequest, {
            url: `${API_BASE_URL}/api/formations`,
            token,
        });
        yield put({ type: FETCH_FORMATIONS_SUCCESS, payload: res.data });
    } catch (e) {
        const msg = e.response?.data?.message || e.message;
        yield put({ type: FETCH_FORMATIONS_FAIL, payload: msg });
    }
}

/* ======================
   CREATE (multipart)
====================== */
export function* createFormationSaga(action) {
    const token = sessionStorage.getItem("token");

    try {
        const payload = action.payload;

        // ✅ clean payload (remove imageFile)
        const cleanPayload = { ...payload };
        delete cleanPayload.imageFile;

        const fd = new FormData();
        fd.append("payload", JSON.stringify(cleanPayload));
        if (payload.imageFile) fd.append("image", payload.imageFile);

        const res = yield call(postRequest, {
            url: `${API_BASE_URL}/api/formations`,
            data: fd,
            token,
        });

        yield put({ type: CREATE_FORMATION_SUCCESS, payload: res.data });

        Swal.fire({ icon: "success", title: "Succès", text: "Formation ajoutée" });
        yield put(fetchFormationsRequest());
    } catch (e) {
        const msg = e.response?.data?.message || e.message || "Erreur création formation";
        yield put({ type: CREATE_FORMATION_FAIL, payload: msg });
        Swal.fire({ icon: "error", title: "Erreur", text: msg });
    }
}

/* ======================
   UPDATE (multipart)
====================== */
export function* updateFormationSaga(action) {
    const token = sessionStorage.getItem("token");

    try {
        const { id, payload } = action.payload;

        const cleanPayload = { ...payload };
        delete cleanPayload.imageFile;

        const fd = new FormData();
        fd.append("payload", JSON.stringify(cleanPayload));
        if (payload.imageFile) fd.append("image", payload.imageFile);

        const res = yield call(putRequest, {
            url: `${API_BASE_URL}/api/formations/${id}`,
            data: fd,
            token,
        });

        yield put({ type: UPDATE_FORMATION_SUCCESS, payload: res.data });

        Swal.fire({ icon: "success", title: "Succès", text: "Formation mise à jour" });
        yield put(fetchFormationsRequest());
    } catch (e) {
        const msg = e.response?.data?.message || e.message || "Erreur update formation";
        yield put({ type: UPDATE_FORMATION_FAIL, payload: msg });
        Swal.fire({ icon: "error", title: "Erreur", text: msg });
    }
}

/* ======================
   DELETE
====================== */
export function* deleteFormationSaga(action) {
    const token = sessionStorage.getItem("token");

    try {
        const id = action.payload;

        yield call(deleteRequest, {
            url: `${API_BASE_URL}/api/formations/${id}`,
            token,
        });

        yield put({ type: DELETE_FORMATION_SUCCESS });

        Swal.fire({ icon: "success", title: "Supprimé", text: "Formation supprimée" });
        yield put(fetchFormationsRequest());
    } catch (e) {
        const msg = e.response?.data?.message || e.message || "Erreur suppression formation";
        yield put({ type: DELETE_FORMATION_FAIL, payload: msg });
        Swal.fire({ icon: "error", title: "Erreur", text: msg });
    }
}

/* ======================
   TEMPLATE
====================== */
export function* downloadTemplateSaga() {
    const token = sessionStorage.getItem("token");

    try {
        const res = yield call(getBlobRequest, {
            url: `${API_BASE_URL}/api/formations/template`,
            token: `Bearer ${token}`,
        });

        downloadBlob(new Blob([res.data]), "template_formations.xlsx");
        yield put({ type: DOWNLOAD_FORMATIONS_TEMPLATE_SUCCESS });
    } catch (e) {
        yield put({ type: DOWNLOAD_FORMATIONS_TEMPLATE_FAIL, payload: e.response?.data || e.message });
        Swal.fire({ icon: "error", title: "Erreur", text: "Téléchargement template échoué" });
    }
}

/* ======================
   IMPORT EXCEL (dryRun + add/edit)
====================== */
export function* importExcelSaga(action) {
    const token = sessionStorage.getItem("token");
    const { file, dryRun, action: act } = action.payload;

    try {
        const fd = new FormData();
        fd.append("file", file);

        const url = `${API_BASE_URL}/api/formations/import?dryRun=${dryRun ? "true" : "false"}&action=${act}`;

        const res = yield call(postRequest, {
            url,
            data: fd,
            token,
        });

        yield put({ type: IMPORT_FORMATIONS_EXCEL_SUCCESS, payload: res.data });

        if (!dryRun) {
            Swal.fire({
                icon: "success",
                title: "Import terminé",
                text: `${res.data.createdCount} lignes traitées, ${res.data.skippedCount} ignorées`,
            });
            yield put(fetchFormationsRequest());
        } else {
            Swal.fire({
                icon: "info",
                title: "Prévisualisation",
                text: `${res.data.createdCount} lignes valides, ${res.data.skippedCount} erreurs`,
            });
        }
    } catch (e) {
        yield put({ type: IMPORT_FORMATIONS_EXCEL_FAIL, payload: e.response?.data || e.message });
        Swal.fire({ icon: "error", title: "Erreur import", text: "Import Excel échoué" });
    }
}

/* ======================
   EXPORT
====================== */
export function* exportExcelSaga() {
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid"); // si ton backend utilise header uid

    try {
        const res = yield call(getBlobRequest, {
            url: `${API_BASE_URL}/api/formations/export`,
            token: `Bearer ${token}`,
            extraHeaders: { uid },
        });


        downloadBlob(new Blob([res.data]), "export_formations.xlsx");
        yield put({ type: EXPORT_FORMATIONS_SUCCESS });
    } catch (e) {
        yield put({ type: EXPORT_FORMATIONS_FAIL });
        Swal.fire({ icon: "error", title: "Erreur", text: "Export échoué" });
    }
}
